import ServiceLocator from "../../global/service-locator";
import lozadObserver from "../../extensions/lozad";
import ModalForm from "../../components/base/forms/modal-form";
import Dropdown from "../../components/base/dropdown";
import {throttle} from "../../lib";
import {AnalyticsService} from "../../services/analytics-service";
import { v4 as uuidv4 } from 'uuid';
import Consent from "../../components/consent";

export default class CoreModule {
    constructor() {
        this.sl = ServiceLocator.instance;

        this.mediaMatches = window.matchMedia('(min-width: 769px)').matches;

        this.initLozad();
        this.initConsultationForm();
        this.initContactsDropdown();
        this.initMobileHeader();
        this.initConsent();
    }

    initLozad() {
        lozadObserver();
    }

    initContactsDropdown() {
        new Dropdown(
            document.querySelector('[data-dropdown-menu="contacts"]'),
            document.querySelector('[data-dropdown-trigger="contacts"]')
        );
    }

    initConsultationForm() {
        const $triggers = document.querySelectorAll(`[data-modal-trigger="b2b-consultation"]`);

        if (!$triggers.length) return;

        const form = new ModalForm({
            formId: `b2b-consultation`,
            uri: '/1.0/b2b/corped',
            $modalTriggers: [...$triggers],
            hash: 'b2b-consultation',
            data: {
                type: craft.page.handle
            },
            subscriptions: [
                {
                    event: 'beforeSubmit',
                    callback: () => {
                        const dataLayerEventData = {
                            event: 'b2b_consultation_form',
                            formId: form.formId,
                            phone: form.data.tel,
                            email: form.data.email
                        };

                        const conversionId = uuidv4();
                        const owoxUserId = costorage.get('ouid');

                        form.addData({ conversionId });

                        if (owoxUserId) {
                            form.addData({ owoxUserId });
                        }

                        dataLayerEventData.conversion_id = conversionId;

                        const $formTitle = form.$root.querySelector('.form_title');

                        if ($formTitle) {
                            dataLayerEventData.formName = $formTitle.textContent;
                        }

                        AnalyticsService.sendEvent('b2b_consultation_form', dataLayerEventData);
                    }
                }
            ]
        });
    }

    initMobileHeader() {
        if (this.mediaMatches) {
            return;
        }

        const $header = document.querySelector('.site-header');
        const $mobileMenuTrigger = document.getElementById('mobileNavMenuTrigger');
        const $mobileMenu = document.getElementById('mobileMenu');
        const $consultation = $mobileMenu.querySelector('[data-modal-trigger="b2b-consultation"]');

        window.addEventListener('scroll', throttle(() => {
            if (window.scrollY > 0) {
                $header.classList.add('-pinned');
            } else {
                $header.classList.remove('-pinned');
            }
        }, 20));

        $mobileMenuTrigger.addEventListener('click', () => {
            document.body.classList.add('-mobile-menu');
            scrollLock.disablePageScroll();
        });

        $consultation.addEventListener('click', () => {
            document.body.classList.remove('-mobile-menu');
            scrollLock.enablePageScroll();
        });

        $mobileMenu.addEventListener('click', (e) => {
            if (e.target.closest('.mobile-menu-nav')) {
                return;
            }

            document.body.classList.remove('-mobile-menu');
            scrollLock.enablePageScroll();
        });
    }

    initConsent() {
        new Consent();
    }
}